import { removeLF } from '@doda/common/src/utils/convTextUtil';

/**
 * 求人ランキング用給与情報テキストを生成する
 * @param salaryExamples 給与例
 * @param salary 給与情報
 * @returns 給与例と給与情報から生成した給与情報テキスト
 */
export const createRankingSalaryText = (
  salaryExamples: string[],
  salary: string
): string => {
  // 給与例が存在しない場合は給与情報の改行コードを取り除いて使用する
  if (salaryExamples.length === 0) return removeLF(salary);

  const firstExample = salaryExamples[0];
  // 給与例1を行ごとに分割
  const firstExampleLines = firstExample.split(/\r\n|\n/);
  if (firstExampleLines.length >= 2) {
    // 給与例1が2行以上存在する場合、給与例1の1行目と2行目を全角スペースで区切る
    return `${firstExampleLines[0]}\u3000${firstExampleLines[1]}`;
  }

  const secondExample = salaryExamples[1];
  if (secondExample) {
    // 給与例2が存在する場合、給与例1と2を全角スペースで区切る
    return `${firstExample}\u3000${secondExample}`;
  }

  return firstExample;
};
